import { FormGroup } from '@angular/forms';
import { Currency } from '@df/interfaces';

export function separateBy(cards: Array<any>, num: number): Array<any> {
    const trArray = [];
    const numOfCols = num;
    for (let i = 0; i < cards.length; i = i + numOfCols) {
        const row = [];
        for (let x = 0; x < numOfCols; x++) {
            const value = cards[i + x];
            if (!value) {
                break;
            }
            row.push(value);
        }
        trArray.push(row);
    }
    return trArray;
}

export function declensionOfNumerals(amount: number, currency: Currency, kairos = false): string {
    const newAmount = Math.abs(amount);
    const cases = [2, 3, 4];
    const nameInAccusative = currency.name_in_accusative;
    const pluralNameLess5 = currency.plural_name_less_5;
    const pluralNameMore5 = currency.plural_name_more_5;
    let titles = [nameInAccusative, pluralNameLess5, pluralNameMore5];

    if (kairos) {
        titles = ['кайрос', 'кайроса', 'кайросов'];
    }

    if (newAmount === 1) {
        return titles[0];
    }

    return cases.includes(newAmount) ? titles[1] : titles[2];
}

export function markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
        control.markAsTouched();

        if (control.controls) {
            markFormGroupTouched(control);
        }
    });
}

export function smoothScrollToTop(step = 30) {
    const scrollToTop = window.setInterval(() => {
        const pos = window.pageYOffset;
        if (pos > 0) {
            window.scrollTo(0, pos - step); // how far to scroll on each step
        } else {
            window.clearInterval(scrollToTop);
        }
    }, 16);
}
